export enum CaptureUserAuditOutcomeStatus {
  compliant = 'compliant',
  compliantWithMinorFindings = 'compliant_with_minor_findings',
  noncompliant = 'noncompliant',
}
